import { Button } from "antd";
import { useCallback, useRef } from "react";
import * as XLSX from 'xlsx';
import { CloudDownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export default function Table2XLSX({ dataSource = [] }) {
    const { t } = useTranslation()
    const tableRef = useRef(null);

    /* Callback invoked when the button is clicked */
    const xport = useCallback(async () => {
        /* Create worksheet from HTML DOM TABLE */
        const table = tableRef?.current;
        const wb = XLSX.utils.table_to_book(table);

        /* Export to file (start a download) */
        XLSX.writeFile(wb, `${t('listCabinet')}.xlsx`);
    }, []);

    return (<>
        <table ref={tableRef} style={{ display: 'none' }} >
            <tbody>
                <tr style={{ backgroundColor: 'red' }}>
                    <td>{t('cabinetCode')}</td>
                    <td>{t('cabinetName')}</td>
                    <td>{t('address')}</td>
                    <td>{t('shopCode')}</td>
                </tr>
                {
                    dataSource.map((row, index) => {
                        return (
                            <tr key={index}>
                                <td>{row?.code}</td>
                                <td>{row?.name}</td>
                                <td>{row?.address}</td>
                                <td>{row?.shop_code}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
        <Button type='primary' size="large" icon={<CloudDownloadOutlined />} onClick={xport}>{t('exportExcel')}</Button>
    </>);
}